import { component } from 'flightjs';
import WithAjax from 'tradera/legacy/static/app/data/with-ajax';
import InitData from 'tradera/legacy/static/app/data/init-data';
import History from 'tradera/legacy/static/utils/history';

function NavigationFilter() {
    this._getFilterModal = function (evt, eventData) {
        this.trigger(document, 'data:navigation-filter:before-load', {
            forceStart: true
        });
        this._abortPendingRequests();

        if (eventData.reloadAfterModalClose) {
            this._reloadAfterModalClose();
        }

        const successCallback = function (html) {
            this._refresh(html, eventData.href);
        };

        this._request = this._get({
            url: eventData.href,
            dataType: 'html',
            headers: { 'x-push-state-request': 'true' }
        }).done(successCallback.bind(this));
    };

    this._refresh = function (html, href) {
        const replaceSelector = '[data-result-layout]';

        const $html = $(html),
            $newView = $html.find(replaceSelector),
            $currentView = this.$node.find(replaceSelector);

        const initData = InitData.setFromHtml(html);

        // this.trigger('ui:teardown', initData);

        History.pushState({ href: href }, initData.title, href);

        $currentView.empty().append($newView.contents());
        // var module = require(initData.module);
        // module(initData);

        // if (initData.subModule) {
        //     var subModule = require(initData.subModule);
        //     subModule(initData);
        // }

        this.trigger(document, 'data:navigation-filter:after-load', initData);
    };

    this._abortPendingRequests = function () {
        if (this._request) {
            this._request.reject();
            this._request = null;
        }
    };

    this.after('initialize', function () {
        this.on('ui:modal-filter-ui:on-load', this._getFilterModal);
        this.on(
            document,
            'ui:body-container:on-modal-close',
            this._abortPendingRequests
        );
    });
}

export default component(NavigationFilter, WithAjax);
